import { Component } from 'solid-js'
import GenerateImageOptionButton from './GenerateImageOptionButton'

const GenerateImageActionOptions: Component<{
  updatePrompt: (value: string, replacePrompt: boolean) => void
  currentPrompt: string
}> = (props) => {
  return (
    <div class="flex flex-row flex-wrap gap-3">
      <GenerateImageOptionButton
        title="Standing"
        value="standing"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('standing')}
      />
      <GenerateImageOptionButton
        title="Sitting"
        value="sitting"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('sitting')}
      />
      <GenerateImageOptionButton
        title="Squatting"
        value="squatting"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('squatting')}
      />
      <GenerateImageOptionButton
        title="Lying down"
        value="lying down"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('lying down')}
      />
      <GenerateImageOptionButton
        title="Working Out"
        value="working out"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('working out')}
      />
      <GenerateImageOptionButton
        title="Swimming"
        value="swimming"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('swimming')}
      />
      <GenerateImageOptionButton
        title="Playing Soccer"
        value="playing soccer"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('playing soccer')}
      />
    </div>
  )
}

export default GenerateImageActionOptions
